import clsx from "clsx";
import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import s from "./forgotPassword.module.scss";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
} from "../../../../libs/api/Endpoints";
import { SwrMutationFetcherArgType } from "../../../../libs/api/Endpoints";
import Navigation from "../../../../global components/Navigation/Navigation";
import useDocumentTitle from "../../../../global components/PageTitle";
import { generateResult } from "../../../../global components/ResultModal/ResultModal";
type Inputs = {
  email: string;
};

function ForgotPassword() {
  useDocumentTitle("Admin | Forgot password");
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const { trigger: enterEmail, isMutating } = useSWRMutation(
    "api/admin/auth/forgot-password",
    swrMutationFetcher
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>({ shouldFocusError: false });

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
   
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        requestOption: {
          method: "POST",
          body: JSON.stringify({email:data.email}),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
       await enterEmail(fetcherArg);
      generateResult("success", "Enter your OTP");
      reset();

      navigate(`/auth/resetcode?email=${data.email}`);
    } catch (error: any) {
      const e = parseClientError(error);
      generateResult(
        "error",
        e.message.charAt(0) + e.message.slice(1) || "Something went wrong"
      );
      console.error(e.error); // Log the error for debugging
    }
  };

  return (
    <div className={s.wrapper}>
      <div className={s.navigate}>
        <Navigation />
      </div>
      <div className={s.main}>
        <span className={s.titles}>
          <h3 className={s.title}>
            {currentPath.includes("/change-password") ? "Change" : "Forgot"} {" "}
            password
          </h3>
          <p className={s.subtitle}>
            Provide email address that is associated with this account
          </p>
        </span>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={clsx(s.inputWrapper)}>
            <h5 className={clsx(s.inputLabel)}>Email address</h5>
            <input
              type="email"
              className={clsx(s.input, { [s.inputError]: errors.email })}
              {...register("email", { required: "Email is required" })}
            />
            {errors.email && (
              <span className={clsx(s.errorMessage)}>
                {errors.email.message}
              </span>
            )}
          </div>
          {/* Button component from Ant Design */}
          <Button
            type="default"
            className={clsx(s.button)} // Button style
            htmlType="submit" // Ensures it's tied to form submission
            loading={isMutating}
            disabled={isSubmitting}
          >
            Continue
          </Button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
